import { render, staticRenderFns } from "./ReferenceLink.vue?vue&type=template&id=08ceb648&scoped=true&"
import script from "./ReferenceLink.vue?vue&type=script&lang=js&"
export * from "./ReferenceLink.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceLink.vue?vue&type=style&index=0&id=08ceb648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ceb648",
  null
  
)

export default component.exports